import { isSugarDaddyTheme as isSDT } from "@/service/general";

export default {
    data() {
        return {
            theme: process.env.VUE_APP_THEME
        }
    },
    methods: {
        themeT(key, values) {
            const themedKey = `${key}.${this.theme}`;
            const translated = this.$t(themedKey, values);

            return translated === themedKey ? this.$t(key, values) : translated;
        },

        isSugarDaddyTheme() {
          return isSDT()
        }
    }
}
